import { graphql } from 'gatsby'
import HomePage from '../views/home'

export default HomePage

export const query = graphql`
  query HomeQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      metaDescription
      metaTag
      title
      slug
      pageSection {
        ...servicesFragment
        ... on ContentfulImageAnimation {
          bucketUrl
          href
          image {
            file {
              url
              contentType
            }
          }
        }
        ...featureFragment
        ... on ContentfulSectionHeading {
          id
          sectionHeadings
        }
      }
    }
  }
`
